export const phoneHref = (phone: string | null) => 'tel:+' +  (phone?.replace(/\D/g, '') ?? "")
export const viberHref = (viber: string | null) => 'viber://chat?number=' + (viber?.replace(/\D/g, '') ?? "")
